module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qrepr5-dc1f1dd96dd0c9e13017f6bd64a00ac7.jpg";